import type { RatingPictogramField as Schema } from "shared"
import NeverFace from "../../../assets/pictogram-never.svg?react"
import SometimesFace from "../../../assets/pictogram-sometimes.svg?react"
import AlwaysFace from "../../../assets/pictogram-always.svg?react"
import styles from "./PictogramRatingField.module.scss"

// The child/teen DEX scale is a fixed three points. The caption is the option's
// label (customizable per form, e.g. Never/Sometimes/Always) and its value is the
// DSS value (1/3/5); the faces are brand assets mapped positionally.
const FACES = [NeverFace, SometimesFace, AlwaysFace]

type Props = {
  field: Schema
  value: number | undefined
  onChange: (value: number) => void
  disabled?: boolean
}

export function PictogramRatingField({
  field,
  value,
  onChange,
  disabled,
}: Props) {
  return (
    <fieldset className={styles.fieldset} tabIndex={-1}>
      <legend className={styles.legend}>{field.label}</legend>
      <div className={styles.options}>
        {field.options.map((opt, i) => {
          const Face = FACES[i]
          const selected = value === opt.value
          return (
            <label
              key={opt.value}
              className={`${styles.option} ${
                selected ? styles.optionSelected : ""
              }`}
            >
              <input
                type="radio"
                name={field.id}
                value={opt.value}
                checked={selected}
                onChange={() => onChange(opt.value)}
                disabled={disabled}
                className={styles.input}
                tabIndex={selected || (value === undefined && i === 0) ? 0 : -1}
              />
              <Face
                className={styles.face}
                aria-hidden="true"
                focusable="false"
              />
              <span className={styles.caption}>{opt.label}</span>
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}
